import {
  PURCHASE_OPERATOR_TOKEN_SUCCESS,
  APPEND_OPERATOR_PURCHASE_DETAILS
} from "./actions/constants";

const initialState = {
  operatorTokens: [],
  pin: "",
  loading: false,
  message: "",
  error: null,
  transactionRefNo: "",
  tempWalletBalance: 0
};

function buyOperatorTokenDetailsReducer(state = initialState, action) {
  switch (action.type) {
    case APPEND_OPERATOR_PURCHASE_DETAILS:
      // this is done to handle when the user edits values that is submitted
      const latest = state.operatorTokens.filter(
        operator => operator.operatorId !== action.payload.operatorId
      );
      return {
        ...state,
        operatorTokens: [...latest, action.payload]
      };
    case PURCHASE_OPERATOR_TOKEN_SUCCESS:
      return {
        ...state,
        message: action.payload.message,
        transactionRefNo: action.payload.data.transactionReference,
        tempWalletBalance: action.payload.data.walletBalance
      };

    default:
      return state;
  }
}

export default buyOperatorTokenDetailsReducer;
